"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeEqual = void 0;
const crypto_1 = require("crypto");
exports.safeEqual = (a, b) => {
    try {
        return crypto_1.timingSafeEqual(a, b);
    }
    catch (_a) {
        return false;
    }
};
//# sourceMappingURL=safe-equal.js.map